export default {"src":"/_next/static/media/icon-smartphone-text.61c55505.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};